import { render, staticRenderFns } from "./PcRsNum.vue?vue&type=template&id=2a16f42d&"
import script from "./PcRsNum.vue?vue&type=script&lang=js&"
export * from "./PcRsNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports